import get from 'lodash.get';
import { canUseDOM } from '../../utils/executionEnvironment';
import { getCncCookie } from './cookies';

export const fnIsSwitchToCartItems = () =>
  canUseDOM && (get(window, 'ASOData.uiConfig.cmsGlobal.switchToCartItemApi', false) || getCncCookie('stci'));
